import React, { useState } from "react";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSalesAnalytics } from "../../../hooks/useAnalytics";
import { AnalyticsFilter } from "../../../types/analytics";
import PeriodSelector from "../../../components/backend/analytics/PeriodSelector";
import PieBreakdown from "../../../components/backend/analytics/PieBreakdown";
import TopProductsList from "../../../components/backend/analytics/TopProductsList";
import { useDashboardOverview } from "../../../hooks/useAnalytics";

const ProductPerformancePage: React.FC = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<AnalyticsFilter>({ period: "30d" });
  const { data: salesResponse, isLoading: salesLoading } =
    useSalesAnalytics(filter);
  const { data: overviewResponse, isLoading: overviewLoading } =
    useDashboardOverview(filter);

  const sales = salesResponse?.data;
  const overview = overviewResponse?.data;
  const isLoading = salesLoading || overviewLoading;

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography variant="h4" fontWeight={700}>
          {t("admin.analytics.productPerformance")}
        </Typography>
        <PeriodSelector filter={filter} onChange={setFilter} />
      </Box>

      {overview && sales && (
        <>
          {/* Top Products (full width) */}
          <Box sx={{ mb: 4 }}>
            <TopProductsList
              title={t("admin.analytics.topProducts")}
              products={overview.topProducts}
            />
          </Box>

          {/* Retailer breakdown */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <PieBreakdown
                title={t("admin.analytics.salesByRetailer")}
                data={sales.salesByRetailer}
                height={320}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PieBreakdown
                title={t("admin.analytics.salesByLocation")}
                data={sales.salesByPickupLocation}
                height={320}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default ProductPerformancePage;
